import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { mapOrderItemsForCalculateTotal } from 'utils'

type Items = {
  salePrice: number
  defaultPrice: number
  quantity: number
}

type Params = {
  customerId: string
  invoiceTypeId: string
  unityId: string
  paymentTerm: string
  totalDiscount: number
  totalExpenses: number
  freightPrice: number
  items: Items[]
}

export const loadOrderCalculateTotalWithTaxes = (
  params: Params
): Promise<any> => {
  return axios.post('/orders/calculate-total-taxes', {
    ...params,
    items: mapOrderItemsForCalculateTotal(params.items)
  })
  // return new Promise((resolve) =>
  //   setTimeout(
  //     () =>
  //       resolve({
  //         totalItems: 8402.51,
  //         totalDiscount: 342.51000000000005,
  //         freightPrice: 1161.63,
  //         totalExpenses: 0,
  //         totalWithoutFreight: 8060,
  //         totalIcms: 1,
  //         totalIpi: 2,
  //         totalSt: 3,
  //         totalTaxes: 6,
  //         total: 9221.63,
  //         params
  //       }),
  //     1000
  //   )
  // )
}

export function useLoadOrderCalculateTotalWithTaxes(params: any) {
  return useQuery(
    ['orderCalculateTotal', params],
    () => loadOrderCalculateTotalWithTaxes(params),
    {
      enabled: params?.isTaxesRecalculePending,
      keepPreviousData: true,
      onError: () =>
        toast.error('Não foi possível calcular o total do pedido', {
          toastId: 'orderCalculateTotal'
        })
    }
  )
}
